import Component from "@ember/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { PlanbookCalendarDateCombined } from "@shared/models/planbook-calendar-date-combined"
import type { RotationCalendar } from "@shared/models/rotation-calendar"

export default class PlanbookOutsideSchoolYearNotice extends Component {
  // Args
  planbookDate!: PlanbookCalendarDateCombined
  planbook!: Planbook
  rotationCalendar!: RotationCalendar
  dateString!: string
  visibleCourses!: Array<Course>
  course!: Course
  formatForMonthLayout!: boolean
  typeOfLessonToShow!: string
  editCourseTitleAndOrder!: Function
}
